import CloseIcon from '@mui/icons-material/Close';
import { AppBar, Box, IconButton, Toolbar } from '@mui/material';
import React, { ReactNode } from 'react';

export interface ProcessDialogHeaderProps {
  title: ReactNode;
  onClose: () => void;
  actions?: ReactNode;
}

const ProcessDialogHeader: React.FC<ProcessDialogHeaderProps> = ({
  title,
  onClose,
  actions,
}) => {
  return (
    <AppBar
      sx={{
        position: 'relative',
        boxShadow: 'none',
        borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
      }}
      color="default"
    >
      <Toolbar>
        <Box sx={{ flex: 1 }}>{title}</Box>
        {actions != null && (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mr: 1 }}>
            {actions}
          </Box>
        )}
        <IconButton
          edge="end"
          aria-label="cerrar"
          onClick={onClose}
          size="small"
        >
          <CloseIcon />
        </IconButton>
      </Toolbar>
    </AppBar>
  );
};

export default ProcessDialogHeader;
